export enum BankAccountField {
  Name = 'NAME',
  Agency = 'AGENCY',
  Account = 'ACCOUNT'
}
